import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, TextField, Button, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../config/api';

function SignIn() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError('Please enter email and password');
      return;
    }
    setError('');
    try {
      const res = await fetch(getApiUrl('/api/signin'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.email, password: form.password })
      });
      const data = await res.json();
      if (res.ok && data.success && data.token) {
        // Save user info and token
        const userData = { 
          firstName: data.firstName, 
          lastName: data.lastName, 
          email: data.email || form.email, 
          userType: data.userType 
        };
        login(userData, data.token);
        navigate('/trader-summary');
      } else {
        setError(data.error || 'Invalid email or password');
      }
    } catch (err) {
      setError('Signin failed. Please try again.');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ minWidth: 340, maxWidth: 380, mx: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={700} align="center" mb={2} color="primary">Sign In</Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              name="email"
              label="Email Address"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
              fullWidth
              autoFocus
            />
            <TextField
              name="password"
              label="Password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              fullWidth
            />
            {error && <Alert severity="error">{error}</Alert>}
            <Button variant="contained" type="submit" size="large" sx={{ mt: 1, fontWeight: 600, backgroundColor: '#4ade80 !important', background: '#4ade80 !important', color: '#1e293b', '&:hover': { backgroundColor: '#22c55e !important', background: '#22c55e !important', color: '#1e293b' } }}>
              Sign In
            </Button>
            <Box sx={{ textAlign: 'center', mt: 1 }}>
              <Typography variant="body2" sx={{ color: '#64748b' }}>
                Don't have an account?{' '}
                <Typography 
                  component="span" 
                  sx={{ 
                    color: '#4ade80', 
                    fontWeight: 600, 
                    cursor: 'pointer',
                    '&:hover': { 
                      color: '#22c55e',
                      textDecoration: 'underline'
                    }
                  }}
                  onClick={() => navigate('/signup')}
                >
                  Sign Up
                </Typography>
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default SignIn;
